import * as remoteAction from "../remoteAction";

export type GetSharesActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_SHARES_SUCCESS",
  any
>;
export type GetSharesActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_SHARES_FAILURE",
  any
>;
export type GetSharesActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_SHARES_REQUEST",
  any
>;

export interface GetSharesAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_SHARES_REQUEST";
    success: "GET_SHARES_SUCCESS";
    failure: "GET_SHARES_FAILURE";
  };
}

export function getSharesAction(): GetSharesAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_SHARES_FAILURE",
      request: "GET_SHARES_REQUEST",
      success: "GET_SHARES_SUCCESS",
    },
    https: true,
    url: `/share/shares`,
  };
}
